// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPrivate: React.FC = () => {
    return (
        <svg width="11px" height="13px" viewBox="0 0 11 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="currentColor" fill-rule="evenodd">
                <g id="lock" transform="translate(-0.000000, 0.500000)" fill-rule="nonzero">
                    <path
                        d="M9,5.22890639 L8.62500036,5.25 L8.62500036,3.375 C8.62500036,1.51382804 7.11117232,0 5.25000036,0 C3.3888284,0 1.87500036,1.51382804 1.87500036,3.375 L1.87500036,5.25 L1.5,5.22890639 C0.67148459,5.22890639 0,5.90039062 0,6.72890639 L0,10.4789064 C0,11.3071876 0.671484232,11.9789064 1.5,11.9789064 L9,11.9789064 C9.82851577,11.9789064 10.5,11.3071876 10.5,10.4789064 L10.5,6.72890639 C10.5,5.92265618 9.82734346,5.22890639 9,5.22890639 L9,5.22890639 Z M3.375,3.375 C3.375,2.34093761 4.21640611,1.5 5.25,1.5 C6.28359389,1.5 7.125,2.34093761 7.125,3.375 L7.125,5.25 L3.375,5.25 L3.375,3.375 Z"
                        id="Shape"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconPrivate);
